import classNames from "classnames";
import { stausClass } from ".";

export interface BaseInputProps {
  status?: "success" | "warning" | "error" | "pink" | "done" | "bg" | "default";
  className?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value?: string | number;
  type?: "text" | "number" | "password";
  width?: string;
  name?: string;
  autoComplete?: string;
  inputMode?: "text" | "search" | "email" | "tel" | "url" | "none" | "numeric" | "decimal";
  pattern?: string;
}
function BaseInput({
  className,
  disabled,
  onChange,
  type,
  status = "default",
  placeholder,
  value,
  name,
  width,
  autoComplete,
  inputMode,
  pattern,
  ...otherProps
}: BaseInputProps) {
  const classes = classNames(
    "border  p-2 py-4 rounded-lg text-sm focus:outline-none focus:border-gray-100-mmpz placeholder:text-right",
    stausClass[status],
    {
      "border-gray-100-mmpz hover:border-black-mmpz hover:text-black-mmpz":
        status == "default",
      "border-gray-100-mmpz text-gray-100-mmpz placeholder:text-gray-100-mmpz":
        disabled,
      "text-left": type === "number",
      "w-80": !width,
    },
    width,
    className
  );
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (type === "number") {
      if (
        !(
          (e.key >= "0" && e.key <= "9") ||
          e.key === "Backspace" ||
          e.key === "Delete" ||
          e.key === "ArrowLeft" ||
          e.key === "ArrowRight" ||
          e.key === "Tab"
        )
      ) {
        e.preventDefault();
      }
    }
  };

  return (
    <input
      className={classes}
      type={type}
      value={value}
      name={name}
      disabled={disabled}
      onKeyDown={handleKeyDown}
      onChange={onChange}
      placeholder={placeholder}
      autoComplete={autoComplete}
      inputMode={inputMode}
      pattern={pattern}
      {...otherProps}
    />
  );
}

export default BaseInput;
